module.exports = __webpack_public_path__ + "img/strategies_letgo.3fb821fe.png";